export enum RouteRoadType {
    URBAN = 1,
    RURAL = 2,
    CANTONAL = 3,
    INTRACANTONAL = 4,
    INTERCANTONAL = 5,
    INTERPROVINCIAL = 6 
}